import { Link } from "react-router-dom";
import { Building2, Users, Wrench, Truck, Receipt, Eye } from "lucide-react";
import { useSeo } from "../lib/seo";
import { IMAGES } from "../lib/constants";
import { PageHero } from "../components/Common";
import { PageFade, Reveal } from "../components/Motion";

export const PM_SERVICES = [
  [Building2, "Property Management", "Day-to-day oversight of your commercial asset."],
  [Users, "Tenant Coordination", "Communication, requests and lease-related coordination."],
  [Wrench, "Maintenance Coordination", "Scheduling and tracking routine and urgent maintenance."],
  [Truck, "Vendor Coordination", "Sourcing and managing trusted local vendors."],
  [Receipt, "Rent / Expense Administration", "Organized tracking of rents and operating expenses."],
  [Eye, "Property Oversight", "Local eyes on your property, so you don't have to be there."],
];

export default function PropertyManagement() {
  useSeo("Oregon Commercial Property Management", "Sido Holdings can help simplify commercial real estate ownership in Oregon through property management services, subject to applicable licensing and service availability.");
  return (
    <PageFade>
      <PageHero eyebrow="Property Management" title="Ownership, simplified." image={IMAGES.glass}
        sub="Already own commercial real estate? Sido Holdings can also help simplify the ownership experience through property management services, subject to applicable licensing and service availability." />
      <section className="bg-paper py-20 sm:py-28">
        <div className="container-x">
          <div className="grid gap-px bg-navy/10 border border-navy/10 sm:grid-cols-2 lg:grid-cols-3" data-testid="pm-services">
            {PM_SERVICES.map(([Icon, t, d], i) => (
              <Reveal key={t} delay={i * 0.05} className="bg-white p-8">
                <Icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
                <h3 className="mt-6 text-2xl font-semibold text-navy">{t}</h3>
                <p className="mt-2 text-sm text-ink/70">{d}</p>
              </Reveal>
            ))}
          </div>
          <div className="mt-14 flex flex-col sm:flex-row gap-3">
            <Link to="/contact?type=Property%20management" className="btn-primary" data-testid="pm-contact-btn">Ask About Property Management</Link>
          </div>
          <p className="mt-6 text-xs text-mist max-w-2xl">Property management services are subject to applicable Oregon licensing requirements, written agreements and service availability. Scope and fees are disclosed before any engagement.</p>
        </div>
      </section>
    </PageFade>
  );
}
